import React from 'react';
import programmingHeroCover from '../../assets/images/programmingHeroCover.png';
import programmingHeroLogo from '../../assets/images/programmingHeroLogo.jpg';
const WebDevelopmentCourse = () => {
    return (
        <section className='overflow-hidden'>
            <h2 className='text-green-600 w-full text-center text-3xl md:text-4xl pt-10 pb-8 Black-Ops-One' data-aos="flip-down" >Web Development Course</h2>
            <div className="hero h-96 relative font-Cormorant-Garamond border-y-[1px] border-gray-600" style={{ backgroundImage: `url(${programmingHeroCover})` }}>
                <div className="hero-overlay bg-opacity-[0.95] bg-[#02162b]" data-aos="fade" data-aos-duration="400" ></div>
                <div className="hero-content max-w-full capitalize text-left flex justify-around w-full">
                    <div data-aos="fade-right" data-aos-duration="1000" className="p-0 md:pl-10 2xl:pl-0">
                        <h1 className="mb-3 text-2xl font-bold">Programming Hero</h1>
                        <p className="mb-0 sm:mb-2 text-sm md:text-lg">Platform: Online.</p>
                        <p className="mb-0 sm:mb-2 text-sm md:text-lg">Timeline: January 2022 - July 2022</p>
                        <div className="mb-0 sm:mb-2 text-sm md:text-lg">Achivements:
                            <div className='mb-0 sm:mb-2 text-xs md:text-lg ml-5 list-none'>
                                <li>✓  Won Black Belt</li>
                                <li>✓  Won and Joined Albatross</li>
                                <li>✓  Joined Super Charged Interviewee Club</li>
                            </div>
                        </div>
                        <a
                            target={'blank'}
                            href="https://drive.google.com/file/d/1TOQ4ZPpfEEN_DteW6hiaCRpAw-UgcxNW/view?usp=share_link"
                            className='mb-1 mt-4 mr-5 btn btn-sm  capitalize md:w-48 h-8 md:h-9 font-play font-light rounded text-xs md:text-sm  text-green-400 hover:text-white bg-[#00283ac9] hover:bg-green-600 transition duration-150 ease-in-out border-[1px] border-green-900 hover:border-green-600'>
                            Main Certificate
                        </a>
                        <a
                            target={'blank'}
                            href="https://drive.google.com/file/d/1tYmgmq1QPTa-himzEcZstt2O2UwfgDhx/view?usp=share_link"
                            className='mb-1 mt-4 mr-5 btn btn-sm  capitalize md:w-48 h-8 md:h-9 font-play font-light rounded text-xs md:text-sm  text-green-400 hover:text-white bg-[#00283ac9] hover:bg-green-600 transition duration-150 ease-in-out border-[1px] border-green-900 hover:border-green-600'>
                            Blackbelt Poster
                        </a>
                    </div>
                    <a data-aos="fade-left" data-aos-duration="1000" className='bg-[#ffffff30] rounded-2xl border border-gray-700 hidden lg:block' target={'blank'} href="https://web.programming-hero.com/">
                        <div className='w-32 h-32 flex flex-col justify-center items-center'>
                            <img className='rounded-2xl w-24 h-24' src={programmingHeroLogo} alt="" />
                        </div>
                    </a>
                </div>
            </div>
        </section>
    );
};

export default WebDevelopmentCourse;